const useStyles = () => {
    return {
        iconOutlined: ({ icon }: { icon: string }) => ({
            width: 40,
            height: 40,
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            ...icon === 'phone' && {
                backgroundColor: 'secondary.main',
            },
            ...icon === 'email' && {
                backgroundColor: 'primary.100',
            },
            '& .icon-action-card': {
                fontSize: '25px',
            }
        }),
        flex: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        containerIcons: {
            display: 'flex',
            alignItems: 'center',
            width: '26%',
            justifyContent: 'end',
            gap: 1
        },
    }
}

export { useStyles }